module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAAAAADEa8dEAAABVUlEQVQ4y5VUSY6DMBD0O0oYIZmnsLxq5hSUvAAF8Qou5CVBFl9AyMpphDjUHMw6JMLTp6Yo2e3uqhZ0CDEnz8dz/2cDWFITeQBkomdYJxKAFzcrKQMACQBXy7kuQDaTMiAsDftCATeSvAGq6NmXoWUJsgGSkSQ5RIAmNRANJMkxBhpSkBHCcSplUEjJFGqYgDFERArSQ7k8KYckJe4LUMIjBX8As2AdoFugWwADPCn4gtx0x0ddw98AEg97Ur9iAaoKwfrd25MoUXwmFZCkIOP1MQfSoJCQYtuWA2lqnLBDUPfuWHiXKzsoMY0B8IMgCHzAmDWfxmRVoFOJKb7JrzmXqd7rSddVVVW1IUljc30QXXsktXuSy3UuhV8BlZ+0wKmZTmNxGbCTVFxFt5Nvq9/I950R8r9GOLNUfGrOZDYnLx9sbjY2Jy8OC+Pz6oma/y6xk/gF7+2dHzc6qSsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/new/index/project_icon.png
// module id = ZtJK
// module chunks = 24